var style = {"z-loader":"z-loader","z-loader__bg":"z-loader__bg","z-loader__bg--full":"z-loader__bg--full"};

export { style as default };
//# sourceMappingURL=LoaderGifBase.module.scss.js.map
